import type { RouteRecordRaw } from "vue-router";

/** Application routes (`RouteRecordRaw[]` for Vue Router v4). */
export const appRoutes: RouteRecordRaw[] = [
  {
    path: "/ticketList",
    name: "TicketList",
    component: () => import("@/ticket/ticket.vue"),
  },
  {
    path: "/ticketAdd",
    name: "TicketCreateComponent",
    component: () => import("@/ticket/ticket-create-component.vue"),
  },
  {
    path: "/formSubmission/:selectedContactFormId",
    name: "FormPreviewElement",
    component: () => import("@/form/form-component.vue"),
  },
  {
    path: "/documentManage/:documentId?",
    name: "DocumentManage",
    component: () => import("@/document/views/document-manage.vue"),
  },
  {
    path: "/doc/public/:contentId",
    name: "DocumentView",
    component: () => import("@/document/views/document-view.vue"),
    meta: { hideNavigation: true, public: true },
  },

  {
    path: "/invoiceList",
    name: "InvoiceList",
    component: () => import("@/billing/invoice/invoice-list.vue"),
  },
  {
    path: "/projectList",
    name: "ProjectList",
    component: () => import("@/project/project.vue"),
  },
  {
    path: "/remoteAccess",
    name: "RemoteAccess",
    component: () => import("@/remote-access/remote-access.vue"),
  },
  {
    path: "/assetSummary",
    name: "AssetSummary",
    component: () => import("@/asset/asset-summary.vue"),
  },
  {
    path: "/ticketSummary",
    name: "TicketSummary",
    component: () => import("@/ticket/ticket-summary.vue"),
  },
  {
    path: "/auth/verify",
    name: "MagicLinkVerify",
    component: () => import("@/infrastructure/views/MagicLinkVerify.vue"),
    meta: { hideNavigation: true, public: true },
  },
  {
    path: "/",
    name: "Login",
    component: () => import("@/root/components/Login.vue"),
    meta: { hideNavigation: true, public: true },
  },
];
